import React from "react";
import { getPathSlug } from "../../../assets/Helpers";
import ThemeSection from "../../../components/ThemeSection/ThemeSection";
import UserSettings from "../../../components/UserSettings/UserSettings";
import UserSettingsTitle from "../../../components/UserSettings/UserSettingsTitle/UserSettingsTitle";
import { useQuery } from "@apollo/react-hooks";
import { GET_ORDER } from "../../../queries/ordersQuery";
import "./OrderSingle.scss";

const OrderSingle = () => {
  const orderId = parseInt(getPathSlug(window.location.href), 10);
  const { data: orderData, loading, error } = useQuery(GET_ORDER, {
    skip: !orderId,
  });

  const order = orderData?.customer?.orders?.nodes?.find(o => o.databaseId === orderId) || null;
  const data = order ? { order } : null;
  let content = "";

  if (error) {
    content = (
      <div className="OrderSingle">
        <div className="Order__header">
          <UserSettingsTitle title={`Porosia e kërkuar nuk është gjetur`} />
        </div>
      </div>
    );
  }

  if (loading) {
    content = (
      <div className="OrderSingle">
        <div className="Order__header">
          <UserSettingsTitle title={`Duke u ngarkuar...`} />
        </div>
      </div>
    );
  }

  if (data && data.order === null) {
    content = (
      <div className="Order__header">
        <UserSettingsTitle title={`Porosia e kërkuar nuk është gjetur`} />
      </div>
    );
  }

  if (data && data.order) {
    content = (
      <div className="OrderSingle">
        <div className="Order__header">
          <UserSettingsTitle title={`Porosia #${data.order.databaseId}`} />
        </div>
        <div className="OrderSingle__content">
          {data.order.lineItems &&
            data.order.lineItems.nodes.map((item, index) => {
              const product = item.product?.node;
              return (
              <div className="CartItem" key={index}>
                <div className="CartItem__thumb">
                  {product?.image && (
                    <img
                      src={product.image.sourceUrl || product.image.mediaItemUrl}
                      alt={product.name}
                    />
                  )}
                </div>
                <div className="CartItem__content">
                  {product?.name && (
                    <h3 className="CartItem__info CartItem__info--title">
                      <b>Produkti:</b> {product.name}
                    </h3>
                  )}
                  {item.total && (
                    <h3 className="CartItem__info">
                      <b>Çmimi:</b> {product?.price?.replace("&nbsp;", "") || product?.price}
                    </h3>
                  )}
                  {item.quantity && (
                    <h4 className="CartItem__info">
                      <b>Sasia:</b> {item.quantity}
                    </h4>
                  )}
                  {item.total && (
                    <h4 className="CartItem__total">
                      <b>Totali:</b> {item.total.replace("&nbsp;", "")}
                    </h4>
                  )}
                </div>
              </div>
            );
            })}
        </div>
        <div className="OrderSingle__summary">
          <h4 className="OrderSingle__summary__title">Përmbledhja e porosisë</h4>
          {data.order.subtotal && (
            <div className="OrderSingle__summary__row">
              <span>Subtotal</span>
              <span>{data.order.subtotal.replace("&nbsp;", "")}</span>
            </div>
          )}
          {data.order.shippingTotal && (
            <div className="OrderSingle__summary__row">
              <span>Transporti</span>
              <span>{data.order.shippingTotal.replace("&nbsp;", "")}</span>
            </div>
          )}
          {data.order.paymentMethod && (
            <div className="OrderSingle__summary__row">
              <span>Mënyra e pagesës</span>
              <span className="OrderSingle__summary__method">{data.order.paymentMethod.toUpperCase()}</span>
            </div>
          )}
          {data.order.total && (
            <div className="OrderSingle__summary__row OrderSingle__summary__row--total">
              <span>Totali</span>
              <span>{data.order.total.replace("&nbsp;", "")}</span>
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="OrderSingle">
      <UserSettings>
        <ThemeSection>{content}</ThemeSection>
      </UserSettings>
    </div>
  );
};

export default OrderSingle;
